import securityCheck from "core/services/securityService/adapter-security-check";

const filterTemplates = (selectedSearchOptions, templatesList) => {
    const resultSet = templatesList.filter(template => {
        let qualified = securityCheck.checkIfEnabledSync(template.uses);
        selectedSearchOptions.forEach(option => {
            qualified = qualified && template.tags.includes(typeof option === "object" ? option.value : option);
        });
        if (qualified) {
            return template;
        }
    });
    return resultSet;
};

export default filterTemplates;
